var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboardWrapper"}},_vm._l((_vm.widgets),function(widget,i){return _c('DashboardWidget',{key:i},[_c(widget.component,{tag:"component"})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }